import axios from "axios";
import API_URL from "../config/apiConfig";

const restaurantHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

const withEntitlements = ({ data }) => ({ ...data.subscription, entitlements: data.entitlements });

export const getSubscription = (restaurantId) =>
  axios
    .get(`${API_URL}/api/restaurants/${restaurantId}/subscription`, { headers: restaurantHeaders() })
    .then(withEntitlements);

export const changeSubscriptionPlan = (restaurantId, { plan, billingCycle }) =>
  axios
    .patch(`${API_URL}/api/restaurants/${restaurantId}/subscription`, { plan, billingCycle }, { headers: restaurantHeaders() })
    .then(withEntitlements);
